import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 21v-6m2 0v-1.5m0 9v-1.5m-2 -3h3m-1 0h.5a1.5 1.5 0 0 1 0 3h-3.5m3 -3h.5a1.5 1.5 0 0 0 0 -3h-3.5","key":"svg-0"}],["path",{"d":"M13.222 14.882a5 5 0 0 1 -1.222 -.882a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v5","key":"svg-1"}],["path",{"d":"M5 21v-7","key":"svg-2"}]]

const IconFlagBitcoin = createReactComponent('outline', 'flag-bitcoin', 'FlagBitcoin', __iconNode);

export default IconFlagBitcoin;